import React from "react";
import "./ProductAssignment.css";

const ProductAssignmentModal = ({ onSelect }) => {
  return (
    <div className="modal-backdrop">
      <div className="modal-box">
        <h2>Ne yapmak istiyorsunuz?</h2>
        <p className="subtitle">Lütfen işlem türünü seçin.</p>
        <div className="option-row">
          <button className="modal-option" onClick={() => onSelect("assign")}>
            <span role="img" aria-label="assign">
              🧑‍💻
            </span>
            <h4>Ürün Atama</h4>
            <p>Kullanıcıya özel ürün ataması yap.</p>
          </button>

          <button className="modal-option" onClick={() => onSelect("generate")}>
            <span role="img" aria-label="generate">
              🔢
            </span>
            <h4>Kod Oluşturma</h4>
            <p>Bir ürün için promosyon kodları oluştur.</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductAssignmentModal;
